import React from "react";

const Preview =(props)=>(
    <div className="preview-note">
        {props.children}
    </div>

)

export default Preview;